/**
 * Simple WhatsApp Chat Widget
 * Modified to open booking modal for consultation requests
 */

class WhatsAppChat {
  constructor(config) {
    this.config = {
      phoneNumber: config.phoneNumber || '',
      businessName: config.businessName || 'Support',
      agentName: config.agentName || 'Agent',
      welcomeMessage: config.welcomeMessage || 'Hello! How can we help?',
      buttonText: config.buttonText || 'Start Chat',
      avatarIcon: config.avatarIcon || '💬',
      quickReplies: config.quickReplies || []
    };
    
    this.init();
  }

  init() {
    this.createWidget();
    this.attachEvents();
  }

  createWidget() {
    const widget = document.createElement('div');
    widget.className = 'whatsapp-chat-widget';
    
    widget.innerHTML = `
      <div class="whatsapp-chat-bubble">
        <div class="whatsapp-chat-header">
          <div class="whatsapp-chat-avatar" style="position: relative;">
            ${this.config.avatarIcon}
            <div class="whatsapp-online-status"></div>
          </div>
          <div class="whatsapp-chat-info">
            <h3>${this.config.agentName}</h3>
            <p>Online now</p>
          </div>
          <button class="whatsapp-close-button">&times;</button>
        </div>
        
        <div class="whatsapp-chat-body">
          <div class="whatsapp-message">
            <p class="whatsapp-message-text">${this.config.welcomeMessage.replace(/\n/g, '<br>')}</p>
            <div class="whatsapp-message-time">${this.getTime()}</div>
          </div>
          
          ${this.config.quickReplies.length > 0 ? `
            <div class="whatsapp-quick-replies">
              ${this.config.quickReplies.map(reply => 
                `<button class="whatsapp-quick-reply" data-reply="${reply}">${reply}</button>`
              ).join('')}
            </div>
          ` : ''}
        </div>
        
        <div class="whatsapp-chat-footer">
          <button class="whatsapp-chat-cta">
            <svg viewBox="0 0 24 24">
              <path d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.816 9.816 0 0 0 12.04 2m.01 1.67c2.2 0 4.26.86 5.82 2.42a8.225 8.225 0 0 1 2.41 5.83c0 4.54-3.7 8.23-8.24 8.23-1.48 0-2.93-.39-4.19-1.15l-.3-.17-3.12.82.83-3.04-.2-.32a8.188 8.188 0 0 1-1.26-4.38c.01-4.54 3.7-8.24 8.25-8.24M8.53 7.33c-.16 0-.43.06-.66.31-.22.25-.87.86-.87 2.07 0 1.22.89 2.39 1 2.56.14.17 1.76 2.67 4.25 3.73.59.27 1.05.42 1.41.53.59.19 1.13.16 1.56.1.48-.07 1.46-.6 1.67-1.18.21-.58.21-1.07.15-1.18-.07-.1-.23-.16-.48-.27-.25-.14-1.47-.74-1.69-.82-.23-.08-.37-.12-.56.12-.16.25-.64.81-.78.97-.15.17-.29.19-.53.07-.26-.13-1.06-.39-2-1.23-.74-.66-1.23-1.47-1.38-1.72-.12-.24-.01-.39.11-.5.11-.11.27-.29.37-.44.13-.14.17-.25.25-.41.08-.17.04-.31-.02-.43-.06-.11-.56-1.35-.77-1.84-.2-.48-.4-.42-.56-.43-.14 0-.3-.01-.47-.01z"/>
            </svg>
            ${this.config.buttonText}
          </button>
        </div>
      </div>
      
      <button class="whatsapp-chat-button" aria-label="Open WhatsApp Chat">
        <svg viewBox="0 0 24 24">
          <path d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.816 9.816 0 0 0 12.04 2m.01 1.67c2.2 0 4.26.86 5.82 2.42a8.225 8.225 0 0 1 2.41 5.83c0 4.54-3.7 8.23-8.24 8.23-1.48 0-2.93-.39-4.19-1.15l-.3-.17-3.12.82.83-3.04-.2-.32a8.188 8.188 0 0 1-1.26-4.38c.01-4.54 3.7-8.24 8.25-8.24M8.53 7.33c-.16 0-.43.06-.66.31-.22.25-.87.86-.87 2.07 0 1.22.89 2.39 1 2.56.14.17 1.76 2.67 4.25 3.73.59.27 1.05.42 1.41.53.59.19 1.13.16 1.56.1.48-.07 1.46-.6 1.67-1.18.21-.58.21-1.07.15-1.18-.07-.1-.23-.16-.48-.27-.25-.14-1.47-.74-1.69-.82-.23-.08-.37-.12-.56.12-.16.25-.64.81-.78.97-.15.17-.29.19-.53.07-.26-.13-1.06-.39-2-1.23-.74-.66-1.23-1.47-1.38-1.72-.12-.24-.01-.39.11-.5.11-.11.27-.29.37-.44.13-.14.17-.25.25-.41.08-.17.04-.31-.02-.43-.06-.11-.56-1.35-.77-1.84-.2-.48-.4-.42-.56-.43-.14 0-.3-.01-.47-.01z"/>
        </svg>
      </button>
    `;

    document.body.appendChild(widget);
    
    this.bubble = widget.querySelector('.whatsapp-chat-bubble');
    this.button = widget.querySelector('.whatsapp-chat-button');
    this.closeBtn = widget.querySelector('.whatsapp-close-button');
    this.ctaBtn = widget.querySelector('.whatsapp-chat-cta');
  }

  attachEvents() {
    this.button.addEventListener('click', () => this.toggle());
    this.closeBtn.addEventListener('click', () => this.close());
    this.ctaBtn.addEventListener('click', () => this.openWhatsApp());
    
    const quickReplies = document.querySelectorAll('.whatsapp-quick-reply');
    quickReplies.forEach(btn => {
      btn.addEventListener('click', (e) => {
        const buttonText = e.target.dataset.reply;
        
        // **MODIFIED: Check if this is a booking/consultation request**
        if (buttonText.includes('Consultation') || buttonText.includes('Book')) {
          // Close the WhatsApp chat bubble
          this.close();
          
          // Open the booking modal if available
          if (typeof window.openBookingModal === 'function') {
            window.openBookingModal();
          } else {
            console.error('Booking modal function not found. Make sure booking-modal.js is loaded.');
            // Fallback to WhatsApp if modal isn't available
            const message = `Hello, I would like to book a consultation with ${this.config.businessName} to discuss jewelry options. When are you available?`;
            this.openWhatsApp(message);
          }
          return;
        }
        
        // For other buttons, use WhatsApp as before
        let message = '';
        
        if (buttonText.includes('Engagement')) {
          message = `Hello, I'm interested in learning more about engagement rings from ${this.config.businessName}. Could you provide more information?`;
        } else if (buttonText.includes('Fine Jewelry')) {
          message = `Hello, I'm interested in exploring fine jewelry pieces from ${this.config.businessName}. What collections do you have available?`;
        } else if (buttonText.includes('Question') || buttonText.includes('Ask')) {
          message = `Hello, I have some questions about ${this.config.businessName}'s jewelry collection. Could you help me?`;
        } else {
          // Fallback for any other buttons
          message = `Hello, I'm interested in ${buttonText} from ${this.config.businessName}. Could you provide more information?`;
        }
        
        this.openWhatsApp(message);
      });
    });
  }

  toggle() {
    this.bubble.classList.toggle('active');
  }

  close() {
    this.bubble.classList.remove('active');
  }

  openWhatsApp(customMessage = '') {
    const message = customMessage || `Hello, I'm interested in purchasing jewelry from ${this.config.businessName} and would like more information.`;
    const url = `https://wa.me/${this.config.phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  }

  getTime() {
    const now = new Date();
    return now.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
  }
}

// Initialize when config is available
if (window.whatsappChatConfig) {
  new WhatsAppChat(window.whatsappChatConfig);
} else {
  document.addEventListener('DOMContentLoaded', () => {
    if (window.whatsappChatConfig) {
      new WhatsAppChat(window.whatsappChatConfig);
    }
  });
}
